import React, { useState, useEffect } from "react";
import allImages from "../../../assets/images-import.jsx";
import { useNavbarToggle } from "../../../assets/js/script";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../redux/auth/loginThunk";
import { useNavigate, Link } from "react-router-dom";
import { fetchUserProfile } from "../../../services/newUserService.jsx";
import Cookies from "js-cookie";
import { handleErrors } from "../../../utils/errorHandler.jsx";
import {
  normalizeProfileResult,
  resolveProfileImageUrl,
} from "../../../utils/profileUtils";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("Admin");
  const [profileImage, setProfileImage] = useState(allImages.defaultprofile);

  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate("/auth/signin");
  };

  const { handlenavbarClick, isClass } = useNavbarToggle();
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      const newTheme = prevTheme === "light" ? "dark" : "light";
      Cookies.set("theme", newTheme);
      return newTheme;
    });
  };

  useEffect(() => {
    const storedTheme = Cookies.get("theme");
    if (storedTheme) {
      setTheme(storedTheme);
    }
    document.documentElement.setAttribute("data-layout-mode", theme);
    document.documentElement.classList.remove(
      "layout-mode-light",
      "layout-mode-dark",
    );
    document.documentElement.classList.add(`layout-mode-${theme}`);
  }, [theme]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await fetchUserProfile();
        const profile = normalizeProfileResult(userData?.data?.result);
        if (profile?.userName) {
          setUserName(profile.userName);
        } else {
          setUserName(Cookies.get("userName") || "Admin");
        }
        const imageUrl = resolveProfileImageUrl(profile?.profileImage);
        setProfileImage(imageUrl || allImages.defaultprofile);
      } catch (error) {
        handleErrors(error);
        setProfileImage(allImages.defaultprofile);
      }
    };

    fetchUserData();
  }, []);

  return (
    <header id="page-topbar" className="xcruit-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <button
              type="button"
              onClick={handlenavbarClick}
              className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
              id="topnav-hamburger-icon"
            >
              <span className={`hamburger-icon ${isClass ? "open" : ""}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>

          <div className="d-flex align-items-center gap-1">
            {/* <div className="header-item d-sm-flex">
              <button
                type="button"
                onClick={toggleTheme}
                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none"
                title="Toggle theme"
              >
                <i className="bx bx-moon fs-20"></i>
              </button>
            </div> */}

            <div className="dropdown header-item topbar-user">
              <button
                type="button"
                className="btn shadow-none xc-user-trigger"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center">
                  <img
                    className="rounded-circle header-profile-user"
                    src={profileImage || allImages.defaultprofile}
                    alt={userName || "User"}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = allImages.defaultprofile;
                    }}
                  />
                  <span className="text-start ms-2 d-none d-xl-inline-block">
                    <span className="fw-medium user-name-text">{userName}</span>
                  </span>
                  <i className="ri-arrow-down-s-line ms-1 d-none d-xl-inline-block xc-user-caret"></i>
                </span>
              </button>

              <div
                className="dropdown-menu dropdown-menu-end xc-user-menu"
                aria-labelledby="page-header-user-dropdown"
              >
                <div className="xc-user-menu__head">
                  <img
                    className="xc-user-menu__avatar"
                    src={profileImage || allImages.defaultprofile}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = allImages.defaultprofile;
                    }}
                  />
                  <div>
                    <p className="xc-user-menu__name mb-0">{userName}</p>
                    <span className="xc-user-menu__role">Account</span>
                  </div>
                </div>
                <div className="xc-user-menu__divider" />
                <Link className="dropdown-item" to="/my-profile">
                  <i className="ri-user-line"></i>
                  <span>My Profile</span>
                </Link>
                <Link className="dropdown-item" to="/change-password">
                  <i className="ri-lock-2-line"></i>
                  <span>Change Password</span>
                </Link>
                <div className="xc-user-menu__divider" />
                <button
                  type="button"
                  className="dropdown-item xc-user-menu__logout"
                  onClick={handleLogout}
                >
                  <i className="ri-logout-box-r-line"></i>
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
